import pink from '@mui/material/colors/pink';

const secondary = pink;

export const lightTheme = ({ primary, width }) => ({
  isDark: false,
  palette: {
    background: {
      default: '#fafafa'
    },
    primary: {
      main: primary
    },
    secondary,
    info: { main: '#2196f3' },
    success: { main: '#4caf50' },
    warning: { main: '#ff9800' },
    error: { main: '#f44336' }
  },
  drawerWidth: width,
  editor: {
    rules: [
      { background: 'fafafa' },
      { token: 'keyword.js', foreground: primary },
      { token: 'string.js', foreground: secondary[500] }
    ],
    colors: {
      'editor.background': '#ffffff',
      'editorGutter.background': '#fafafa',
      'editorLineNumber.foreground': '#6e6e6e',
      'editor.lineHighlightBackground': '#fafafa',
      'editor.selectionBackground': primary + '30'
    }
  },
  tabs: {
    backgroundColor: '#eeeeee'
  },
  tab: {
    backgroundColor: 'white',
    border: 'solid thin #dddddd',
    selected: {
      backgroundColor: 'white'
    }
  },
  warningColor: '#fff176',
  actionLinkColor: '#0000ff',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // restore the body font layout  from MUI version 4
        // (cf. https://github.com/mui/material-ui/pull/24018#issue-766947601)
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em'
        }
      }
    },
    MuiLink: {
      defaultProps: {
        // restore the behavior from MUI version 4, i.e. underline only on hover and not always as in version 5
        underline: 'hover'
      }
    }
  }
});

export const darkTheme = ({ primary, width }) => ({
  isDark: true,
  palette: {
    mode: 'dark',
    background: {
      default: '#303030',
      paper: '#424242'
    },
    primary: {
      main: primary
    },
    secondary
  },
  drawerWidth: width,
  editor: {
    rules: [
      { background: '2c2c2c' },
      { token: 'keyword.js', foreground: primary },
      { token: 'string.js', foreground: secondary[500] }
    ],
    colors: {
      'editor.background': '#303030',
      'editorGutter.background': '#2c2c2c',
      'editor.lineHighlightBackground': '#2c2c2c',
      'editor.selectionBackground': primary + '30'
    }
  },
  tabs: {
    backgroundColor: '#2c2c2c'
  },
  tab: {
    backgroundColor: '#303030',
    border: 'solid thin rgba(255, 255, 255, 0.12)',
    selected: {
      backgroundColor: '#424242'
    }
  },
  warningColor: '#726527',
  actionLinkColor: '#33a0ff',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // restore the body font layout  from MUI version 4
        // (cf. https://github.com/mui/material-ui/pull/24018#issue-766947601)
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em'
        }
      }
    },
    MuiLink: {
      defaultProps: {
        // restore the behavior from MUI version 4, i.e. underline only on hover and not always as in version 5
        underline: 'hover'
      }
    },
    MuiPaper: {
      // unset the background for elevation in dark mode introduced in MUI version 5, which also prevents elevation
      // from lightening the background color, cf.:
      //   - https://v5.mui.com/material-ui/migration/v5-component-changes/#paper
      //   - https://v5.mui.com/material-ui/react-paper/#elevation)
      styleOverrides: { root: { backgroundImage: 'unset' } }
    }
  }
});
